export const ChartLegendConstants = {
  defaultShowLegend: true,
  defaultOrientation: 'horizontal' as const,
  gap: '8px',
  itemGap: '7px',
  py: '0px',
  /** Matches Recharts MoM line legend strip (Figma 32×18). */
  markerViewBoxW: 32,
  markerViewBoxH: 18,
  labelFontSize: '12px',
  labelFontWeight: '500',
  labelFontFamily: 'Montserrat, sans-serif',
  labelLineHeight: '15px',
}

export const ChartLegendStyles = {
  stack: {
    gap: ChartLegendConstants.gap,
    py: ChartLegendConstants.py,
  },
  item: {
    gap: ChartLegendConstants.itemGap,
  },
  label: {
    fontSize: ChartLegendConstants.labelFontSize,
    fontWeight: ChartLegendConstants.labelFontWeight,
    fontFamily: ChartLegendConstants.labelFontFamily,
    lineHeight: ChartLegendConstants.labelLineHeight,
  },
}
